import { useState } from 'react';
import { NavLink } from 'react-router-dom';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const getLinkClass = (isActive: boolean) =>
    `font-heading text-lg tracking-wider transition-colors duration-200 ${
      isActive
        ? 'text-brand-primary bg-brand-primary/10'
        : 'text-brand-heading hover:text-brand-primary'
    }`;

  const mobileLinkClass = (isActive: boolean) =>
    `block px-3 py-2 rounded-md text-base ${getLinkClass(isActive)}`;

  return (
    <header className="bg-checkered-pattern sticky top-0 z-50 border-b border-brand-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo with Glassmorphic Container */}
          <div className="bg-brand-surface/20 backdrop-blur-sm border border-white/10 rounded-lg shadow-lg">
            <NavLink
              to="/"
              className="block px-4 py-2 font-heading text-3xl tracking-widest text-brand-primary transition-colors"
            >
              Primatif
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-2 bg-brand-surface/20 backdrop-blur-sm border border-white/10 rounded-lg p-1 shadow-lg">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `px-4 py-2 rounded-md ${getLinkClass(isActive)}`
              }
              end
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-4 py-2 rounded-md ${getLinkClass(isActive)}`
              }
            >
              About
            </NavLink>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              type="button"
              className="bg-brand-surface/20 backdrop-blur-sm border border-white/10 inline-flex items-center justify-center p-2 rounded-md text-brand-heading hover:text-brand-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-bg focus:ring-brand-primary"
              aria-controls="mobile-menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {isMobileMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state. */}
      {isMobileMenuOpen && (
        <div className="md:hidden" id="mobile-menu">
          <nav className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-brand-surface/90 backdrop-blur-sm border-t border-white/10">
            <NavLink
              to="/"
              className={({ isActive }) => mobileLinkClass(isActive)}
              onClick={() => setIsMobileMenuOpen(false)}
              end
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) => mobileLinkClass(isActive)}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
